import { render, staticRenderFns } from "./ComprometimentoAprovar.vue?vue&type=template&id=64adbecd&"
import script from "./ComprometimentoAprovar.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoAprovar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports